module.exports = __webpack_public_path__ + "img/Corvus.90461e30.png";